import React from "react";

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Politique de confidentialité – Kok Batay
        </h1>
        <p className="text-gray-600 mb-6">
          La présente politique explique comment Kok Batay collecte, utilise et protège vos données personnelles.
        </p>

        {/* 1. Collecte des informations */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            1. Collecte des informations
          </h2>
          <p className="text-gray-700">
            Nous collectons les informations que vous nous fournissez directement lors de votre inscription, telles que
            votre nom, votre adresse e-mail, votre numéro de téléphone, ainsi que les informations liées à vos
            transactions sur la plateforme.
          </p>
        </section>

        {/* 2. Utilisation des données */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            2. Utilisation des données
          </h2>
          <p className="text-gray-700">
            Vos données sont utilisées pour vous fournir nos services, gérer votre compte, traiter vos paiements,
            améliorer la plateforme et vous informer des mises à jour ou offres spéciales.
          </p>
        </section>

        {/* 3. Partage des données */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            3. Partage des données
          </h2>
          <p className="text-gray-700">
            Kok Batay ne vend pas vos données personnelles. Nous pouvons partager certaines informations avec des
            prestataires de services de confiance (paiement, sécurité, hébergement) uniquement dans le but de faire
            fonctionner la plateforme.
          </p>
        </section>

        {/* 4. Sécurité */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            4. Sécurité des données
          </h2>
          <p className="text-gray-700">
            Nous mettons en place des mesures techniques et organisationnelles pour protéger vos données contre tout
            accès non autorisé, modification, divulgation ou destruction.
          </p>
        </section>

        {/* 5. Cookies */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            5. Cookies
          </h2>
          <p className="text-gray-700">
            Nous utilisons des cookies pour améliorer votre expérience de navigation, analyser le trafic et personnaliser
            le contenu. Vous pouvez gérer vos préférences de cookies dans les paramètres de votre navigateur.
          </p>
        </section>

        {/* 6. Droits des utilisateurs */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            6. Vos droits
          </h2>
          <p className="text-gray-700">
            Vous avez le droit d'accéder, de corriger ou de supprimer vos données personnelles, ainsi que de demander
            la limitation ou l’opposition à leur traitement. Pour exercer ces droits, contactez-nous à :
            <span className="font-semibold"> support@kokbatay.com</span>.
          </p>
        </section>

        {/* 7. Modifications de la politique */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            7. Modifications de la politique
          </h2>
          <p className="text-gray-700">
            Kok Batay se réserve le droit de modifier cette politique à tout moment. Toute modification sera publiée sur
            cette page avec la date de mise à jour.
          </p>
        </section>

        {/* Bouton retour */}
        <div className="mt-8">
          <a
            href="/"
            className="inline-block bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600"
          >
            Retour à l'accueil
          </a>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
